export default __webpack_public_path__ + "static/media/headerLogo.b451f82d.png";